import { createStore } from 'vuex'

// Modules
import product from './product'
import cart from './cart'
import language from './language'
import packeta from "../packages/store/packeta";
import discountCoupon from "../packages/store/discount-coupon";
import fileUploader from "../packages/store/file-uploader";
import cropper from "../packages/store/cropper";
import loader from "../packages/store/loader";
import productService from "../packages/store/product-service";
import orderService from "../packages/store/order-service";

// [CUSTOM]
import instaUploader from './custom/insta/file-uploader.js'
import instaCropper from './custom/insta/cropper.js'
import photoUploader from './custom/photo/file-uploader.js'
import photoCropper from './custom/photo/cropper.js'
import discountPopup from './custom/discount-popup'

export default createStore({
    modules: {
        orderService,
        productService,
        loader,
        cropper,
        fileUploader,
        discountCoupon,
        packeta,
        product,
        cart,
        language,
        // [CUSTOM]
        instaUploader,
        instaCropper,
        photoUploader,
        photoCropper,
        discountPopup,
    },
    strict: process.env.DEV,
})
